var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5656 15.2642C24.622 14.1624 24.1933 13.2075 24.1933 11.5853V11.0337C24.1933 8.91981 23.7067 7.55779 22.6489 6.19577C21.0186 4.08053 18.2739 2.80566 15.5871 2.80566H15.4728C12.8424 2.80566 10.1838 4.02199 8.52523 6.05137C7.40967 7.44071 6.86664 8.86127 6.86664 11.0337V11.5853C6.86664 13.2075 6.46612 14.1624 5.49433 15.2642C4.77929 16.076 4.55078 17.1193 4.55078 18.2484C4.55078 19.3789 4.92178 20.4495 5.66635 21.3198C6.63814 22.3631 8.01045 23.0292 9.4123 23.145C11.4419 23.3765 13.4715 23.4637 15.5306 23.4637C17.5884 23.4637 19.618 23.318 21.6489 23.145C23.0494 23.0292 24.4218 22.3631 25.3935 21.3198C26.1368 20.4495 26.5091 19.3789 26.5091 18.2484C26.5091 17.1193 26.2806 16.076 25.5656 15.2642",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.125 25.0585C17.4793 24.9206 13.5447 24.9206 12.8989 25.0585C12.3469 25.186 11.75 25.4826 11.75 26.133C11.7821 26.7535 12.1454 27.3012 12.6486 27.6486L12.6473 27.6499C13.2982 28.1572 14.062 28.4798 14.8618 28.5956C15.288 28.6541 15.7219 28.6515 16.1635 28.5956C16.962 28.4798 17.7258 28.1572 18.3767 27.6499L18.3754 27.6486C18.8786 27.3012 19.2419 26.7535 19.274 26.133C19.274 25.4826 18.677 25.186 18.125 25.0585",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNew);
export default __webpack_public_path__ + "static/media/Notification-new.559c1ea7ad7e174fc5338f0ad190a3ef.svg";
export { ForwardRef as ReactComponent };